import * as React from 'react'

import { styles } from './styling'
import { LightTooltip } from '@sales-center/components'
import InfoOutlined from '@mui/icons-material/InfoOutlined'

export const UseSystemNameLabel = () => {
  return (
    <>
      <span style={styles.useSystemNameContainer}>Use System Name</span>{' '}
      <LightTooltip
        sx={{
          ...styles.tooltipHotspot,
        }}
        title="System Name uses service codes added to Opportunity"
      >
        <InfoOutlined
          sx={styles.icon}
          data-test-id="addOpportunityUseSystemNameInfoIcon"
        />
      </LightTooltip>
    </>
  )
}
UseSystemNameLabel.displayName = 'UseSystemNameLabel'
